<template>
	<div class="login-register-component">
		<div class="login-register-component__content">
			<h4 class="header">Meagur</h4>
			<div class="signup-section" v-if="!loginSelected">
				<div class="register-form" v-if="!alreadyRegisteredWithSocial">
					<form @submit.prevent="thisRegister">
						<div class="form-group">
							<input class="text-input input--primary font-size--medium" type="text" placeholder="Name" v-model="registerName" required>
						</div>
						<div class="form-group">
							<input class="text-input input--primary font-size--medium" type="email" placeholder="Email" v-model="registerEmailOrMobile" required>
						</div>
						<div class="form-group">
							<input id="password" class="text-input input--primary font-size--medium" type="password" placeholder="Password" v-model="registerPassword" required :class="{ invalid: showRegisterPasswordInvalid }">
							<i class="material-icons show-icon" v-if="showPassword" @click="togglePasswordVisible">visibility_off</i>
							<i class="material-icons show-icon" v-else @click="togglePasswordVisible">visibility</i>
							<div class="requirements" v-if="showRegisterPasswordInvalid">
								<ul>
									<li>Minimum of 8 characters</li>
								</ul>
							</div>
						</div>
						<div class="form-group">
							<input class="btn btn--form-submit font-size--medium" type="submit" value="Sign Up">
						</div>
					</form>
					<div class="login-now" v-if="!loginSelected">
						<p>Already have an account? <span @click="showLogin">Login Now</span></p>
					</div>
				</div>				
				<div class="already-registered-with-social" v-else>
					<p class="already-registered-with-social__it-appears">It looks like you've already signed up with {{ providers }} in the past. You can continue now with either social provider. If you'd like to set a password for future logins, you'll be able to do so as soon as you continue with one of your current social providers.</p>
				</div>
			</div>
			<div class="login-section" v-else>
				<div class="login-form" v-if="!alreadyRegisteredWithSocial">
					<form @submit.prevent="login">
						<div class="form-group">
							<input class="text-input input--primary font-size--medium" type="email" placeholder="Email" v-model="loginEmail" required>
						</div>
						<div class="form-group">
							<input class="text-input input--primary font-size--medium" type="password" placeholder="Password" v-model="loginPassword" required>
							<div class="requirements" v-if="showLoginInvalid">
								<ul>
									<li>Those credentials are incorrect</li>
								</ul>
							</div>
						</div>
						<div class="forgot-password-group">
							<router-link class="forgot-password" :to="{ name: 'home' }">Forgot Password?</router-link>
						</div>
						
						<div class="form-group">
							<input class="btn btn--form-submit font-size--medium" type="submit" value="Login">
						</div>
					</form>
					<div class="login-now">
						<p>Don't have an account? <span @click="loginSelected = false">Signup Now</span></p>
					</div>
				</div>
				<div class="already-registered-with-social" v-else>
					<p class="already-registered-with-social__it-appears">It looks like you've already signed up with {{ providers }} in the past, but never set a password. You can continue now with either social provider or set a password for future logins.  If you'd like to set a password, we first need to verify your email.</p>
					<button class="auth-btn email-signin send-code" @click="sendVerifyEmail">
						<span class="icon"></span>
						<span class="text">Send Verification Code</span>
					</button>
				</div>
			</div>
			<p class="or" v-if="!alreadyRegisteredWithSocial">Or</p>
			<div class="social-section">
				<facebook-login class="facebook" v-on:login="socialLogin"></facebook-login>
				<google-login class="google" v-on:login="socialLogin"></google-login>
			</div>
			
			<i class="material-icons md-36 close-button" @click="SET_LOGIN_REGISTER(false)">close</i>
			<div class="email-already-used" v-if="showEmailAlreadyUsed">
				<div class="email-already-used__content">
					<i class="material-icons close-button" @click="showEmailAlreadyUsed = false">close</i>
					<p>An account already exists with that email. You can login now, or reset your password if you've forgotten it.</p>
					<button @click="showLogin">Login Now</button>
					<button>Reset Password</button>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	import { mapMutations, mapActions } from 'vuex'
	import FacebookLogin from '@/components/auth/ContinueWithFacebookButton'
	import GoogleLogin from '@/components/auth/ContinueWithGoogleButton'

	export default {
		components: {
			'facebook-login': FacebookLogin,
			'google-login': GoogleLogin,
		},
		data() {
			return {
				loginSelected: false,
				registerName: '',
				registerEmailOrMobile: '',
				registerPassword: '',
				alreadyRegisteredWithSocial: false,
				alreadyRegisteredWithSocialResponse: {},
				loginEmail: '',
				loginPassword: '',
				showEmailAlreadyUsed: false,
				showLoginInvalid: false,
				showPassword: false,
			}
		},
		computed: {
			providers() {
				if (!this.alreadyRegisteredWithSocial) {
					return ""
				} else {
					var response = this.alreadyRegisteredWithSocialResponse.providers[0].provider.charAt(0).toUpperCase() + this.alreadyRegisteredWithSocialResponse.providers[0].provider.substring(1)
					if(this.alreadyRegisteredWithSocialResponse.providers.length > 1) {
						response = response + " and " + this.alreadyRegisteredWithSocialResponse.providers[1].provider.charAt(0).toUpperCase() + this.alreadyRegisteredWithSocialResponse.providers[1].provider.substring(1)
					}
					return response
				}
			},
			showRegisterPasswordInvalid() {
				if (this.registerPassword.length > 0 && this.registerPassword.length < 8) {
					return true
				} else {
					return false
				}
			}
		},
		methods: {
			...mapMutations([
				'SET_LOGIN_REGISTER',
				'SET_VERIFY_EMAIL',
				'HTTP_FINISHED'
			]),
			...mapActions([
				'loginWithProvider',
				'loginWithEmail',
				'register',
				'sendEmailVerificationLink',
			]),
			showLogin() {
				this.registerName = ''
				this.registerEmailOrMobile = ''
				this.registerPassword = ''
				this.alreadyRegisteredWithSocial = false
				this.alreadyRegisteredWithSocialResponse = {}
				this.showEmailAlreadyUsed = false
				this.loginSelected = true
			},
			socialLogin(provider) {
				const hello = this.hello

				hello(provider).login({ scope: 'email' }).then(() => {
					const authResponse = hello(provider).getAuthResponse()

					this.loginWithProvider({
						provider: provider,
						token: authResponse.access_token
					}).then(() => {
						this.HTTP_FINISHED()
					})
				})
			},
			thisRegister() {
				if(this.registerPassword.length < 8) {
					return
				}
				this.register({
					name: this.registerName,
					email: this.registerEmailOrMobile,
					password: this.registerPassword,
					password_confirmation: this.registerPassword
				}).then(() => {
					this.SET_LOGIN_REGISTER(false)
					this.SET_VERIFY_EMAIL({ show: true, email: this.registerEmailOrMobile, continueToSetPassword: false})
					this.HTTP_FINISHED()
				}).catch(error => {
					if(error.response.data.code == 211) {
						this.registerPassword = ''
						this.alreadyRegisteredWithSocial = true
						this.alreadyRegisteredWithSocialResponse = error.response.data.data
					} else if(error.response.data.code == 400) {

						this.registerPassword = ''
						this.showEmailAlreadyUsed = true
					}
					this.HTTP_FINISHED()
				})
			},
			sendVerifyEmail() {
				var email = null
					if(this.registerEmailOrMobile == '') {
						email = this.loginEmail
					} else {
						email = this.registerEmailOrMobile
					}
				this.sendEmailVerificationLink({ email: email })
					.then(() => {
						this.SET_LOGIN_REGISTER(false)
						
						this.SET_VERIFY_EMAIL({ show: true, email: email, continueToSetPassword: true})
						this.HTTP_FINISHED()
					}).catch(() => {
						this.HTTP_FINISHED()
					})
			},
			login() {
				this.loginWithEmail({
					email: this.loginEmail,
					password: this.loginPassword
				}).then(() => {
					this.HTTP_FINISHED()
				}).catch(error => {
					if(error.response.data.code == 426) {
						this.alreadyRegisteredWithSocial = true
						this.alreadyRegisteredWithSocialResponse = error.response.data.data
						this.HTTP_FINISHED()
					} else {
						this.loginPassword = ''
						this.showLoginInvalid = true
						this.HTTP_FINISHED()
					}
				})
			},
			togglePasswordVisible() {
				if(document.getElementById('password').type == 'password') {
					document.getElementById('password').type = 'text'
					this.showPassword = true
				} else {
					document.getElementById('password').type = 'password'
					this.showPassword = false
				}
			},
		}
	}
</script>

<style lang="scss">
	@import '@/styles/app';
	@import '../../styles/components/auth/loginRegister'
</style>